import React, { Component } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';

import i18n from '../i18n';

import '../assets/stylesheets/Setting.css';

class SettingsView extends Component {
  handleLanguageChange = () => {
    const currentLanguage = localStorage.getItem('language');
    if (currentLanguage === 'fr' ) {
        localStorage.setItem('language', 'en');
        i18n.changeLanguage('en');
    } else {
      localStorage.setItem('language', 'fr');
      i18n.changeLanguage('fr');
    }
  }

  render() {
    return (
      <>
        <Grid container direction='column'>
          <Grid item>
            <LanguageIcon />
            <Typography>
              {i18n.t('chooseLanguage')}
            </Typography>
          </Grid>
          <Grid>
            <Button 
              className='ssenseButton ssensePrimary' 
              onClick={this.handleLanguageChange}
            >
              {i18n.t('alternateLanguage')}
            </Button>
          </Grid>
          
        </Grid>
      </>
    );
  }
}

export default SettingsView;
